export  enum EBOrderSettlementType {
        POS = 1,
        Cash = 2,
        Bank= 3
}